
import { addAdminColumn } from '../../vulcan-lib';

addAdminColumn({
  name: '_id',
});
